/**
 * WhatsappHeaderIcon — Badge icon for the main header.
 * Shows unread message count. Navigates to /whatsapp on click.
 * Pattern follows TaskButton in HeaderContent.
 */

import { Box, Badge, Tooltip, ButtonBase } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { MdWhatsapp } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import useNotificationsStore from 'contexts/notifications/notificationsStore';

const WhatsappHeaderIcon = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useAuth();
  const unreadCount = useNotificationsStore(state => state.whatsappUnreadCount);

  // Hide for tecnico users (role 200)
  if (user?.role === 200) return null;

  if (!user?.customVars?.whatsappEnabled) return null;

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title="WhatsApp" arrow>
        <ButtonBase
          onClick={() => navigate('/whatsapp')}
          sx={{
            borderRadius: '8px',
            p: '6px',
            color: 'text.primary',
            '&:hover': {
              bgcolor: theme.palette.mode === 'dark' ? 'background.default' : 'grey.100'
            }
          }}
          aria-label="abrir whatsapp"
        >
          <Badge
            badgeContent={unreadCount > 99 ? '99+' : unreadCount}
            color="success"
            sx={{
              '& .MuiBadge-badge': {
                fontSize: '0.85rem',
                minWidth: 20,
                height: 20,
                padding: '0 5px'
              }
            }}
          >
            <MdWhatsapp size={28} color={theme.palette.primary.main} />
          </Badge>
        </ButtonBase>
      </Tooltip>
    </Box>
  );
};

export default WhatsappHeaderIcon;
